import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const SINGLE_REVIEW_PAGE_REQUEST = 'SINGLE_REVIEW_PAGE_REQUEST';
export const SINGLE_REVIEW_PAGE_SUCCESS = 'SINGLE_REVIEW_PAGE_SUCCESS';
export const SINGLE_REVIEW_PAGE_ERROR = 'SINGLE_REVIEW_PAGE_ERROR';

export function getSingleReviewRequestAction() {
	return { type: SINGLE_REVIEW_PAGE_REQUEST };
}

export function getSingleReviewSuccessAction(data) {
	return { type: SINGLE_REVIEW_PAGE_SUCCESS, data };
}

export function getSingleReviewErrorAction(error) {
	return { type: SINGLE_REVIEW_PAGE_ERROR, error };
}

export default function fetchSingleReviewPage(reviewId) {
	return dispatch => {
		dispatch(getSingleReviewRequestAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/reviews/permalink',
				query: {
					reviewId: reviewId
				}
			})
		).then(
			json => dispatch(getSingleReviewSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getSingleReviewErrorAction(err));
			}
		);
	};
}
